<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Select Committees</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Close">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!-- Search Bar -->
  <ion-toolbar>
    <ion-searchbar
      [(ngModel)]="searchTerm"
      (ionInput)="filterCommittees()"
      placeholder="Search committees..."
      debounce="300"
      animated="true"
      showClearButton="always">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="modal-content-wrapper">
    <!-- Selected Committees Section -->
    <div class="section-container" *ngIf="selectedCount > 0">
      <div class="section-header selected-header">
        <ion-icon name="checkmark-circle" class="section-icon"></ion-icon>
        <h3 class="section-title">Selected</h3>
        <ion-badge color="primary" class="count-badge">{{selectedCount}}</ion-badge>
      </div>

      <ion-list class="committee-list">
        <ion-item
          *ngFor="let committee of getSelectedCommittees()"
          lines="full"
          button="true"
          (click)="toggleCommittee(committee)"
          class="committee-item selected-item">
          <ion-checkbox
            slot="start"
            [checked]="true"
            (ionChange)="toggleCommittee(committee, $event)"
            aria-label="Deselect committee">
          </ion-checkbox>
          <ion-label class="committee-label">{{committee.name}}</ion-label>
          <ion-icon
            slot="end"
            name="remove-circle-outline"
            class="remove-icon"
            color="danger">
          </ion-icon>
        </ion-item>
      </ion-list>
    </div>

    <!-- Available Committees Section -->
    <div class="section-container" *ngIf="hasFilteredResults">
      <div class="section-header available-header">
        <ion-icon name="list-outline" class="section-icon"></ion-icon>
        <h3 class="section-title">Available</h3>
        <ion-badge color="medium" class="count-badge">{{availableCount}}</ion-badge>
      </div>

      <ion-list class="committee-list">
        <ion-item
          *ngFor="let committee of getAvailableCommittees()"
          lines="full"
          button="true"
          (click)="toggleCommittee(committee)"
          class="committee-item available-item">
          <ion-checkbox
            slot="start"
            [checked]="false"
            (ionChange)="toggleCommittee(committee, $event)"
            aria-label="Select committee">
          </ion-checkbox>
          <ion-label class="committee-label" [innerHTML]="highlightMatch(committee.name)"></ion-label>
          <ion-icon
            slot="end"
            name="add-circle-outline"
            class="add-icon"
            color="primary">
          </ion-icon>
        </ion-item>
      </ion-list>
    </div>

    <!-- No Results State -->
    <div class="empty-state" *ngIf="noSearchResults">
      <ion-icon name="search-outline" class="empty-icon"></ion-icon>
      <h3 class="empty-title">No committees found</h3>
      <p class="empty-text">Try adjusting your search term</p>
    </div>

    <!-- No Committees Available -->
    <div class="empty-state" *ngIf="allCommittees.length === 0">
      <ion-icon name="people-outline" class="empty-icon"></ion-icon>
      <h3 class="empty-title">No committees available</h3>
      <p class="empty-text">Please contact your administrator</p>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="footer-actions">
      <!-- Left Actions -->
      <div class="footer-left">
        <ion-button
          fill="clear"
          color="danger"
          (click)="clearAll()"
          [disabled]="selectedCount === 0">
          <ion-icon slot="start" name="trash-outline"></ion-icon>
          Clear All
        </ion-button>

        <ion-button
          fill="clear"
          color="primary"
          (click)="selectAll()"
          [disabled]="availableCount === 0">
          <ion-icon slot="start" name="checkbox-outline"></ion-icon>
          Select All
        </ion-button>
      </div>

      <!-- Right Actions -->
      <div class="footer-right">
        <ion-button
          fill="solid"
          color="primary"
          (click)="confirm()">
          <ion-icon slot="start" name="checkmark-circle"></ion-icon>
          Done
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>
